export const getDefaultState = () => {
  return {
    presignedURL: null,
    fileS3ObjectUrl: null
  };
};
